import React from 'react';
import { Phone, Share2, BookUser, Mail, MapPin, MessageCircle, Instagram, ArrowUpRight, Handshake } from 'lucide-react';

export const THEMES = {
  baseplus: { name: 'BasePlus', bgA: '#07070d', bgB: '#08262b', accent: '#1ad4be', capA: '#10c0d4', capB: '#28f499' },
  oceano: { name: 'Oceano', bgA: '#06101f', bgB: '#0b2a4a', accent: '#3ba7ff', capA: '#1d6fd8', capB: '#38c8e6' },
  esmeralda: { name: 'Esmeralda', bgA: '#0b1f3a', bgB: '#0f3d2e', accent: '#8bc34a', capA: '#0d47a1', capB: '#7cb342' },
  por_do_sol: { name: 'Pôr do sol', bgA: '#1c0d0d', bgB: '#3a1410', accent: '#ff7043', capA: '#ff7043', capB: '#ffb74d' },
  violeta: { name: 'Violeta', bgA: '#100a24', bgB: '#241049', accent: '#a78bfa', capA: '#6d4cff', capB: '#c084fc' },
};

/** Cartão digital no celular (recriado como componente). `compact` reduz o tamanho para usar como detalhe. */
const PhoneCard = ({ theme = 'baseplus', name = 'Mariana Souza', role = 'Diretora comercial', company, compact = false, className = '' }) => {
  const t = THEMES[theme] || THEMES.baseplus;
  const w = compact ? 'w-[210px]' : 'w-[260px] sm:w-[290px]';
  const Round = ({ icon: Icon, label, big }) => (
    <div className="flex flex-col items-center gap-1">
      <span
        className={`flex items-center justify-center rounded-full border ${big ? (compact ? 'w-10 h-10' : 'w-12 h-12') + ' text-[#06281b]' : (compact ? 'w-7 h-7' : 'w-9 h-9') + ' bg-white/10 border-white/15'}`}
        style={big ? { background: t.accent, borderColor: t.accent } : undefined}
      >
        <Icon className={compact ? (big ? 'w-4 h-4' : 'w-3 h-3') : (big ? 'w-5 h-5' : 'w-4 h-4')} />
      </span>
      <span className={`leading-tight text-white/90 text-center ${compact ? 'text-[7px] max-w-[34px]' : 'text-[9px]'}`}>{label}</span>
    </div>
  );
  return (
    <div className={`${w} shrink-0 rounded-[34px] border-[6px] border-[#1b1b22] bg-black shadow-[0_30px_70px_-20px_rgba(0,0,0,0.7)] overflow-hidden ${className}`}>
      <div className="relative text-white" style={{ background: `linear-gradient(180deg, ${t.bgA}, ${t.bgB})` }}>
        <div className="mx-auto mt-2 h-1.5 w-16 rounded-full bg-white/15" />
        <div className="h-24 mx-3 mt-2 rounded-2xl" style={{ background: `linear-gradient(135deg, ${t.capA}, ${t.capB})` }} />
        <div className="-mt-10 flex justify-center">
          <span className="w-20 h-20 rounded-full flex items-center justify-center text-3xl font-extrabold bg-[#06130f] border-[3px]" style={{ borderColor: t.capB, color: t.accent }}>{name[0]}</span>
        </div>
        <div className="mt-2 text-center px-3">
          <div className="text-lg font-extrabold leading-tight">{name}</div>
          <div className="text-[11px] text-white/65">{role}{company ? ` · ${company}` : ''}</div>
        </div>
        <div className={`mt-3 flex items-start justify-center px-2 ${compact ? 'gap-1.5' : 'gap-2.5'}`}>
          <Round icon={Phone} label="Ligar" />
          <Round icon={Share2} label="Enviar" />
          <Round icon={BookUser} label="Salvar na agenda" big />
          <Round icon={Mail} label="E-mail" />
          <Round icon={MapPin} label="Local" />
        </div>
        <div className="mt-3 mx-3 rounded-2xl border px-3 py-2.5 flex items-center gap-2.5" style={{ borderColor: `${t.accent}99`, background: `${t.accent}1a` }}>
          <span className="w-8 h-8 rounded-lg flex items-center justify-center text-[#06281b]" style={{ background: t.accent }}><Handshake className="w-4 h-4" /></span>
          <span className="flex-1 min-w-0">
            <span className="block text-[12px] font-bold leading-tight">Vamos nos conectar?</span>
            <span className="block text-[9px] text-white/60 leading-tight">Deixe seu contato e eu retorno</span>
          </span>
          <ArrowUpRight className="w-3.5 h-3.5 text-white/60" />
        </div>
        {!compact && (
          <div className="mt-2 mx-3 space-y-2">
            {[[MessageCircle, 'WhatsApp'], [Instagram, 'Instagram']].map(([Icon, label]) => (
              <div key={label} className="rounded-2xl border border-white/10 bg-white/10 px-3 py-2.5 flex items-center gap-2.5">
                <span className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center"><Icon className="w-4 h-4" /></span>
                <span className="flex-1 text-[12px] font-semibold">{label}</span>
                <ArrowUpRight className="w-3.5 h-3.5 text-white/50" />
              </div>
            ))}
          </div>
        )}
        <div className="py-3 text-center text-[8px] text-white/35">Feito com BasePlus</div>
      </div>
    </div>
  );
};

export default PhoneCard;
